export default "<app-ui-header></app-ui-header>\n<router-outlet></router-outlet>\n<app-ui-footer></app-ui-footer>"